import React, { Component } from 'react';
import { loadCSS } from 'fg-loadcss/src/loadCSS';
import Icon from '@material-ui/core/Icon';
class ScrollButton extends Component {
  componentDidMount() {
    loadCSS(
      'https://use.fontawesome.com/releases/v5.1.0/css/all.css',
      document.querySelector('#insertion-point-jss')
    );
  }
  render() {
    return <Icon className="fas fa-arrow-up" />;
  }
}

export default ScrollButton;



// WEBPACK FOOTER //
// ./src/ScrollButton.js